import { render, staticRenderFns } from "./importOrderTemplateConfig.vue?vue&type=template&id=dff3f7dc&"
import script from "./importOrderTemplateConfig.vue?vue&type=script&lang=js&"
export * from "./importOrderTemplateConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dff3f7dc')) {
      api.createRecord('dff3f7dc', component.options)
    } else {
      api.reload('dff3f7dc', component.options)
    }
    module.hot.accept("./importOrderTemplateConfig.vue?vue&type=template&id=dff3f7dc&", function () {
      api.rerender('dff3f7dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/importOrderTemplateConfig.vue"
export default component.exports